import { React } from 'react';
import {
  MonthlyBar,
  SidebarStyle,
  ColumnStyle,
  ColumnOneStyle,
  GreenColorStyle,
  OrangeColorStyle,
  SoldTextStyle,
  RowStyle,
  SidebarMonthText,
} from '../../../atoms/sidebar/sidebar.styles';
import { MotifChip } from '@ey-xd/motif-react';
import { formatNumberWithKAndM, uppercaseFirstLetter } from '../../../../util/commonUtil';
import { useRecoilValue } from 'recoil';
import { Recoil_Quarter_State } from '../../../../recoil/recoil';
import {
  CHIP,
  MONTH_QUARTER_STATUS,
  PERIOD,
  QUARTERLY_DETAILS,
} from '../../../../constants/commonConstants';

const MonthlySidebar = props => {
  let propsData = props.propsData;
  let monthDataInfo = props.quarterData['months'];
  let quarterDataInfo = props.quarterData['quarterlyCalculation'];
  let quarterInfo = useRecoilValue(Recoil_Quarter_State);
  let forecast_type;
  let month;

  forecast_type = propsData?.forecast_type;
  month = propsData?.month;
  if (month != undefined) month = month.charAt(0).toUpperCase() + month.slice(1);

  const getValue = (value, tag) => {
    if (tag === MONTH_QUARTER_STATUS.NOT_APPLICABLE) {
      return QUARTERLY_DETAILS.NOT_APPLICABLE;
    } else {
      return formatNumberWithKAndM(value) || 0;
    }
  };

  return (
    <>
      {!!monthDataInfo && !!quarterInfo && (
        <MonthlyBar aria-live="polite">
          {monthDataInfo.map(item => (
            <SidebarStyle
              setBorader={
                forecast_type == 'month' && uppercaseFirstLetter(item.month).slice(0, 3) == month
                  ? true
                  : false
              }
            >
              <ColumnOneStyle>
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <SidebarMonthText className={!quarterDataInfo ? 'beyond-text-only' : null}>
                    {' '}
                    {!quarterDataInfo && <span>All beyond &nbsp;</span>}
                    {uppercaseFirstLetter(item.month).slice(0, 3)}
                  </SidebarMonthText>

                  {!!quarterInfo &&
                    uppercaseFirstLetter(item.month).slice(0, 3) == quarterInfo.month && (
                      <div>
                        <MotifChip
                          style={{
                            backgroundColor: '#ffe600',
                            color: '#0000000',
                          }}
                        >
                          {CHIP.CURRENT}
                        </MotifChip>
                      </div>
                    )}

                  {uppercaseFirstLetter(item.month).slice(0, 3) != quarterInfo.month &&
                    item?.calculation?.period == PERIOD.FUTURE && (
                      <div>
                        <MotifChip style={{ backgroundColor: '#1a1a24', color: '#fff' }}>
                          {CHIP.FUTURE}
                        </MotifChip>
                      </div>
                    )}
                </div>
              </ColumnOneStyle>

              {item?.calculation?.period == PERIOD.PAST && (
                <ColumnStyle>
                  {' '}
                  <RowStyle>
                    <GreenColorStyle />
                    <SoldTextStyle>{QUARTERLY_DETAILS.WON}</SoldTextStyle>
                  </RowStyle>
                  <span>{getValue(item?.calculation?.sold, item?.calculation?.tag)}</span>
                </ColumnStyle>
              )}

              {item?.calculation?.period == PERIOD.PAST && (
                <ColumnStyle>
                  {' '}
                  <RowStyle>
                    <SoldTextStyle>{QUARTERLY_DETAILS.FORECASTED}</SoldTextStyle>
                  </RowStyle>
                  <span>{getValue(item?.calculation?.commit, item?.calculation?.tag)}</span>
                </ColumnStyle>
              )}

              {/* For Future Month */}
              {item?.calculation?.period != PERIOD.PAST && <ColumnStyle></ColumnStyle>}

              {item?.calculation?.period == PERIOD.CURRENT && (
                <ColumnStyle>
                  {' '}
                  <RowStyle>
                    <SoldTextStyle>{QUARTERLY_DETAILS.COMMIT}</SoldTextStyle>
                  </RowStyle>
                  <span>{getValue(item?.calculation?.commit, item?.calculation?.tag)}</span>
                </ColumnStyle>
              )}

              {item?.calculation?.period == PERIOD.FUTURE && (
                <ColumnStyle>
                  {' '}
                  <RowStyle>
                    <OrangeColorStyle />
                    <SoldTextStyle>{QUARTERLY_DETAILS.PROJECTED}</SoldTextStyle>
                  </RowStyle>
                  <span>{getValue(item?.calculation?.commit, item?.calculation?.tag)}</span>
                </ColumnStyle>
              )}

              {!!quarterDataInfo && (
                <ColumnStyle>
                  <RowStyle>
                    <SoldTextStyle>{QUARTERLY_DETAILS.NO_COMMIT}</SoldTextStyle>
                  </RowStyle>
                  <span>{getValue(item?.calculation?.noCommit, item?.calculation?.tag)}</span>
                </ColumnStyle>
              )}
            </SidebarStyle>
          ))}
        </MonthlyBar>
      )}
    </>
  );
};

export default MonthlySidebar;
